export const initAssets = [
  'brand/anim/skeleton.json',
  'atlases/init-0.json',
  'atlases/init-1.json',
  'atlases/init-2.json',
]
export const splashAssets = [
  'animations/spine/intro/skeleton.json',
  'animations/spine/logos/main/skeleton.json',
  'animations/spine/fullscreen/skeleton.json',
  'brand/images/brand.png',
  'atlases/splash-0.json',
  'atlases/base-0.json',
]
export const assets = [
  'animations/spine/back/freespin/skeleton.json',
  'animations/spine/back/main/skeleton.json',
  'animations/spine/fs-end/skeleton.json',
  'animations/spine/fs-start/skeleton.json',
  'animations/spine/items/1/skeleton.json',
  'animations/spine/items/2/skeleton.json',
  'animations/spine/items/A/skeleton.json',
  'animations/spine/items/B/skeleton.json',
  'animations/spine/items/C/skeleton.json',
  'animations/spine/items/D/skeleton.json',
  'animations/spine/items/E/skeleton.json',
  'animations/spine/items/F/skeleton.json',
  'animations/spine/items/G/skeleton.json',
  'animations/spine/items/H/skeleton.json',
  'animations/spine/items/I/skeleton.json',
  'animations/spine/items/J/skeleton.json',
  'animations/spine/lines/skeleton.json',
  'animations/spine/logos/freeplay-sc/skeleton.json',
  'animations/spine/logos/freespin/skeleton.json',
  'animations/spine/multiplier/skeleton.json',
  'animations/spine/reel-main/skeleton.json',
  'animations/spine/scatter/skeleton.json',
  'animations/spine/win/skeleton.json',
  'bitmap/bitmap.xml',
  'atlases/main-0.json',
]
export const particle = ['atlases/particle-0.json']
